/**
 * One money format for OMS figures: £, two decimals, thousands comma.
 * 1962 → "£1,962.00", 8.6 → "£8.60", -3.5 → "-£3.50". Non-numbers → "£0.00".
 */
export const formatGbp = value => {
  const n = Number(value)
  if (value === null || value === '' || !Number.isFinite(n)) return '£0.00'
  const [whole, pence] = Math.abs(n).toFixed(2).split('.')
  const sign = n < 0 && Math.abs(n) >= 0.005 ? '-' : ''
  return `${sign}£${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${pence}`
}

export const EXPECTED_STOCK_NEGATIVE_DISPLAY = '—'
export const EXPECTED_STOCK_NEGATIVE_HINT = 'Check units'

export const isNegativeExpectedStockValue = value => {
  const n = Number(value)
  return Number.isFinite(n) && n < 0
}

export const formatExpectedStockValue = value =>
  expectedQtyHasNoVarianceBaseline(value)
    ? EXPECTED_STOCK_NEGATIVE_DISPLAY
    : formatGbp(value)

/** Expected 0 or unreadable: no % variance (would be a fake 0%). */
export const expectedQtyHasNoVarianceBaseline = expectedQty => {
  const n = Number(expectedQty)
  return !Number.isFinite(n) || n <= 0
}

/**
 * True when Expected can show a real £ on a list card.
 * 0 / negative / uncounted still render the column with a placeholder.
 */
export const shouldShowStockTakeListExpected = (
  expectedStockValue,
  stockCounted,
) => {
  if (stockCounted === false) return false
  return !expectedQtyHasNoVarianceBaseline(expectedStockValue)
}

export const formatStockTakeExpectedQtyDisplay = ({
  expectedQty,
  unitDisplay = '0',
} = {}) => {
  if (expectedQtyHasNoVarianceBaseline(expectedQty)) {
    return {
      text: EXPECTED_STOCK_NEGATIVE_DISPLAY,
      hint: EXPECTED_STOCK_NEGATIVE_HINT,
      unreliable: true,
    }
  }
  return {
    text: unitDisplay,
    hint: 'Expected Quantity = Last Stock + Received – Sold – Wastage',
    unreliable: false,
  }
}

export const formatStockTakeVarianceDisplay = ({
  expectedQty,
  unitDisplay = '0',
  percentDisplay = '0',
} = {}) => {
  if (expectedQtyHasNoVarianceBaseline(expectedQty)) {
    return {
      text: EXPECTED_STOCK_NEGATIVE_DISPLAY,
      hint: EXPECTED_STOCK_NEGATIVE_HINT,
      unreliable: true,
    }
  }
  return {
    text: `${unitDisplay} (${percentDisplay}%)`,
    hint: 'Variance = In Stock - Expected Quantity. Shows the difference between actual and expected stock levels.',
    unreliable: false,
  }
}

export default formatGbp
